(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-table-configuration"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('variant-table-configuration')) {
    customElements.define('variant-table-configuration', class extends HTMLElement {
      connectedCallback() {
        this.productSection = this.closest('.product__section');
        if (!this.productSection) return;

        this.productSection.addEventListener('change', () => {
          window.setTimeout(() => this.update(), 0);
        });
      }

      update() {
        const variantInput = this.productSection.querySelector('input[name="id"]');
        const content = this.querySelector('[data-variant-table-configuration-content]');
        const selectedOptions = Array.from(this.productSection.querySelectorAll('.js-variant-selector')).map((selector) => {
          const checkedInput = selector.querySelector('input:checked');
          const select = selector.matches('select') ? selector : selector.querySelector('select');
          return checkedInput ? checkedInput.value : select && select.value;
        });
        const templates = Array.from(this.querySelectorAll('[data-variant-table-configuration-template]'));
        const optionTemplate = templates.find((candidate) => {
          const options = JSON.parse(candidate.dataset.variantOptions || '[]');
          return options.length === selectedOptions.length && options.every((option, index) => option === selectedOptions[index]);
        });
        const nativeVariantTemplate = variantInput && this.querySelector(`[data-variant-table-configuration-template="${variantInput.value}"]`);
        const template = nativeVariantTemplate || optionTemplate;

        if (!content) return;
        content.innerHTML = template ? template.innerHTML : '';
        this.hidden = !template || content.textContent.trim() === '';
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
